import * as React from "react";

interface FilterIconProps {
    className?: string;
    onClick?: () => void;
}

export class FiltertIcon extends React.Component<FilterIconProps> {
    render() {
        return (
            <div {...this.props} data-testid="filter-icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.5 12H5V11.5C5 11.225 4.775 11 4.5 11H3.5C3.225 11 3 11.225 3 11.5V12H0.5C0.225 12 0 12.225 0 12.5V13.5C0 13.775 0.225 14 0.5 14H3V14.5C3 14.775 3.225 15 3.5 15H4.5C4.775 15 5 14.775 5 14.5V14H15.5C15.775 14 16 13.775 16 13.5V12.5C16 12.225 15.775 12 15.5 12ZM15.5 7H13V6.5C13 6.225 12.775 6 12.5 6H11.5C11.225 6 11 6.225 11 6.5V7H0.5C0.225 7 0 7.225 0 7.5V8.5C0 8.775 0.225 9 0.5 9H11V9.5C11 9.775 11.225 10 11.5 10H12.5C12.775 10 13 9.775 13 9.5V9H15.5C15.775 9 16 8.775 16 8.5V7.5C16 7.225 15.775 7 15.5 7ZM15.5 2H9V1.5C9 1.225 8.775 1 8.5 1H7.5C7.225 1 7 1.225 7 1.5V2H0.5C0.225 2 0 2.225 0 2.5V3.5C0 3.775 0.225 4 0.5 4H7V4.5C7 4.775 7.225 5 7.5 5H8.5C8.775 5 9 4.775 9 4.5V4H15.5C15.775 4 16 3.775 16 3.5V2.5C16 2.225 15.775 2 15.5 2Z" fill="#973794" />
                </svg>
            </div>
        );
    }
}
